export class HBMMedia {
  name?: string;
  url: string;
}

export class HBMMedias {
  render360: HBMMedia[];
  renderHQ: HBMMedia[];
  snapshot: HBMMedia[];
  plan2D: HBMMedia[];
  thumbnail: HBMMedia[];
  crosscut: HBMMedia[];

  constructor() {
    this.render360 = [];
    this.renderHQ = [];
    this.snapshot = [];
    this.plan2D = [];
    this.thumbnail = [];
    this.crosscut = [];
  }

  get allMedias(): HBMMedia[] {
    let allMedias: HBMMedia[] = [];
    allMedias = allMedias.concat(
      this.thumbnail,
      this.render360,
      this.renderHQ,
      this.snapshot,
      this.plan2D,
      this.crosscut
    );
    return allMedias;
  }
}
